import React from "react";
import { Link } from "react-router-dom";

const Footer = ({ openPopup }) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-logo">trademarkIcontext</h3>
            <p className="footer-description">
              America's trusted trademark registration experts. Protecting brands and securing intellectual property rights for businesses nationwide since 2009.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><a href="#services">Trademark Search</a></li>
              <li><a href="#services">Application Filing</a></li>
              <li><a href="#services">Office Action Response</a></li>
              <li><a href="#services">Trademark Monitoring</a></li>
              <li><a href="#services">Brand Protection</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-links">
              <li><a href="#about">About Us</a></li>
              <li><a href="#process">How It Works</a></li>
              <li><a href="#pricing">Pricing</a></li>
              <li><a href="#faqs">FAQs</a></li>
              <li><button onClick={openPopup}>Contact</button></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-links">
              <li><Link to="/privacy-policy" onClick={scrollToTop}>Privacy Policy</Link></li>
              <li><Link to="/terms-conditions" onClick={scrollToTop}>Terms & Conditions</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Contact Info</h4>
            <ul className="footer-contact">
              <li>12100 Wilshire Blvd 8th floor</li>
              <li>Los Angeles, CA 90025</li>
              <li><a href="tel:+11231234567">+1 (123) 123-4567</a></li>
              <li><a href="mailto:info@trademarkincontext.com">info@trademarkincontext.com</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2025 trademarkIcontext. All rights reserved. | USPTO Registered Filing Service
          </p>
          <p className="footer-disclaimer">
            Disclaimer: trademarkIcontext is not a law firm and does not provide legal advice. We are a trademark filing service that works with licensed attorneys.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
